import { GetterTree } from "vuex";
import { ForexMenuItem, ForexState } from "./interface";
import { IStoreRootState } from "@/store/interface";
import { ForexGetter } from "@/feature/Forex/store/constants";
import { ForexCourse } from "@/feature/Forex/api/forex.interface";
import $t from '@/plugins/i18n/i18n';

export default <GetterTree<ForexState, IStoreRootState>> {

	[ForexGetter.menu]: (): ForexMenuItem[] => [
		{
			title: $t.t('forex.buyForeignCurrency') as string,
			imgUrl: '/img/icons/buy-currency.svg',
			urlRoute: { name: 'ForexBuy' }
		},
		{
			title: $t.t('forex.sellForeignCurrency') as string,
			imgUrl: '/img/icons/sell-currency.svg',
			urlRoute: { name: 'ForexSell' }
		},
	],

	[ForexGetter.sidebar]: ({
		templatesCount,
		draftsCount
	}): ForexMenuItem[][] => [
		[
			{
				text: $t.t('home.tabsList.templates') as string,
				imgUrl: '/img/icons/favorite.svg',
				hoveredImgUrl: '/img/icons/favorite--primary.svg',
				urlRoute: { name: 'ForexTemplate' },
				// badgeImgUrl: '/img/icons/chevron-right--silver.svg',
				badgeText: templatesCount,
			},
			{
				text: $t.t('home.statusPayment.draft') as string,
				imgUrl: '/img/icons/edit-pencil.svg',
				hoveredImgUrl: '/img/icons/edit-pencil_primary.svg',
				urlRoute: { name: 'ForexDraft' },
				// badgeImgUrl: '/img/icons/chevron-right--silver.svg'
				badgeText: draftsCount,
			},
		]
	],

	[ForexGetter.courseBuy]: ({ courseBuy }): ForexCourse[] => courseBuy,

	[ForexGetter.courseSell]: ({ courseSell }): ForexCourse[] => courseSell,

}
